<div class="row m-0 personal-info credit-app-body addinfo"  [ngClass]='{"noshadow": isBuyNow || isLegacyCreditApp, "pl-4 pr-4": !isBuyNow && !isLegacyCreditApp}'>
  <form
    novalidate
    (ngSubmit)="goNext()"
    [formGroup]="additionalInfoForm"
    class="col-12 col-lg-11 scrollDiv px-0"
  >
    <div class="row m-0 residence-info">
      <div class="col-12 col-md-4 pl-0 pb-3">
        <label for="additionalIncome">{{ additionalInfoConfigData?.AdditionalIncomeLabel }}</label>
        <div class="dollar-symbol" [ngClass]="{'w-50': isBuyNow || isLegacyCreditApp}">
          <input id="additionalIncome"
                  class="form-control  pr-2"
                  formControlName="AdditionalIncome"
                  #additionalIncome
                  maxlength="6"
                  [ngClass]="{
                    error:
                      ((additionalInfoForm.get('AdditionalIncome').touched ||
                        additionalInfoForm.get('AdditionalIncome').dirty) &&
                        !additionalInfoForm.get('AdditionalIncome').valid) ||
                      (!additionalInfoForm.get('AdditionalIncome').valid &&
                        formSubmitAttempt) ||
                      !additionalInfoForm.get('AdditionalIncome').valid,
                      'w-100': !isBuyNow && !isLegacyCreditApp,
                      'bn-add-wide': isBuyNow || isLegacyCreditApp
                  }"
                  type="text"
                  [dtTextMask]="{ mask: numberMask, guide:false }"
                 />
        </div>
        <span role="button"
          class="form-error-x dt-icon dt-icon-input-clear mt-4"
          *ngIf="
            ((additionalInfoForm.get('AdditionalIncome').touched ||
              additionalInfoForm.get('AdditionalIncome').dirty) &&
              !additionalInfoForm.get('AdditionalIncome').valid) ||
            (!additionalInfoForm.get('AdditionalIncome').valid &&
              formSubmitAttempt) ||
            !additionalInfoForm.get('AdditionalIncome').valid
          " aria-label="Clear additional income"
          (click)="clearValidations(additionalInfoForm.get('AdditionalIncome'))"
          (keyup)="
            $event?.keyCode === 13
              ? clearValidations(additionalInfoForm.get('AdditionalIncome'))
              : null
          "
        >

        </span>
        <div
          class="invalid-feedback d-block"
          *ngIf="
            ((additionalInfoForm.get('AdditionalIncome').touched ||
              additionalInfoForm.get('AdditionalIncome').dirty) &&
              !additionalInfoForm.get('AdditionalIncome').valid) ||
            (!additionalInfoForm.get('AdditionalIncome').valid &&
              formSubmitAttempt) ||
            !additionalInfoForm.get('AdditionalIncome').valid; else dollarMsg
          "
        >
          <span class="form-validator_error">
            <ng-container *ngIf="!!additionalInfoForm.get('AdditionalIncome').errors?.required">
              {{ additionalInfoConfigData?.AdditionalIncomeRequired }}
            </ng-container>
            <ng-container *ngIf="!!additionalInfoForm.get('AdditionalIncome').errors?.min">
              Please enter a value greater that 0
            </ng-container>
          </span>
      </div>
      <ng-template #dollarMsg>
        <div
          class="invalid-feedback d-block"
          *ngIf="hasFocus(additionalIncome) && additionalInfoForm.get('AdditionalIncome').value"
        >
          <span class="form-validator_error">
                Please enter a dollar amount
          </span>
        </div>
      </ng-template>
      </div>
      <div class="col-12 w-100 pl-0">
        <p class="text-left" *ngIf="hasFocus(additionalIncome)" [ngClass]="{'income-disclaimer': !isBuyNow && !isLegacyCreditApp, 'income-disclaimer-buynow': isBuyNow || isLegacyCreditApp}">
          {{additionalInfoConfigData?.AdditionalIncomeDisclaimer}}
        </p>
      </div>
      <div class="col-12 p-0 pb-2">
        <div
          class="row m-0 p-0"
          *ngIf="additionalInfoForm.get('AdditionalIncome').value"
        >
          <!--<div class="col-12 col-lg-6 col-xl-4 pl-0 pr-0 pr-lg-2 pb-3">
            <label>{{ additionalInfoConfigData?.IncomeFrequencyLabel }}</label>
            <select
              class="form-control w-100 gradient"
              formControlName="IncomeFrequency"
              id="IncomeFrequency"
              [ngClass]="{
                error:
                  ((additionalInfoForm.get('IncomeFrequency').touched ||
                    additionalInfoForm.get('IncomeFrequency').dirty) &&
                    !additionalInfoForm.get('IncomeFrequency').valid) ||
                  (!additionalInfoForm.get('IncomeFrequency').valid &&
                    formSubmitAttempt)
              }"
            >
              <option
                value=""
                [selected]="
                  additionalInfoForm.get('IncomeFrequency').value === '' ||
                  additionalInfoForm.get('IncomeFrequency').value === null
                "
              >
                {{ creditAppConfigData?.SelectsDefaultLabel }}
              </option>
              <option
                *ngFor="let IncomeFrequency of incomeFrequencies"
                [value]="IncomeFrequency.Value"
                [selected]="
                  IncomeFrequency.Value ===
                  additionalInfoForm.get('IncomeFrequency').value
                "
              >
                {{ IncomeFrequency.Description }}
              </option>
            </select>
            <div
              class="invalid-feedback d-block"
              *ngIf="
                ((additionalInfoForm.get('IncomeFrequency').touched ||
                  additionalInfoForm.get('IncomeFrequency').dirty) &&
                  !additionalInfoForm.get('IncomeFrequency').valid) ||
                (!additionalInfoForm.get('IncomeFrequency').valid &&
                  formSubmitAttempt); else selectionFrequency
              "
            >
              <span class="form-validator_error">
                <ng-container
                  *ngIf="
                    !!additionalInfoForm.get('IncomeFrequency').errors?.required
                  "
                >
                  {{ additionalInfoConfigData?.IncomeFrequencyRequired }}
                </ng-container>
              </span>
            </div>
            <ng-template #selectionFrequency>
              <div class="invalid-feedback d-block"
                *ngIf="!additionalInfoForm.get('IncomeFrequency').value"
              >
                <span class="form-validator_error">
                    Please make a selection
                </span>
              </div>
            </ng-template>
          </div>-->
          <div class="col-12 col-lg-6 col-xl-4 pl-0 pl-lg-2 pr-0 pb-3">
            <label for="IncomeSource">{{ additionalInfoConfigData?.IncomeSourceLabel }}</label>
            <select
              class="form-control w-100 gradient"
              formControlName="IncomeSource"
              id="IncomeSource"
              [ngClass]="{
                error:
                  ((additionalInfoForm.get('IncomeSource').touched ||
                    additionalInfoForm.get('IncomeSource').dirty) &&
                    !additionalInfoForm.get('IncomeSource').valid) ||
                  (!additionalInfoForm.get('IncomeSource').valid &&
                    formSubmitAttempt)
              }"
            >
              <option
                value=""
                [selected]="additionalInfoForm.get('IncomeSource').value === '' ||
                            additionalInfoForm.get('IncomeSource').value === null"
              >
                {{ creditAppConfigData?.SelectsDefaultLabel }}
              </option>
              <option
                *ngFor="let incomeSource of incomeSources"
                [value]="incomeSource.Value"
                [selected]="
                  incomeSource.Value ===
                  additionalInfoForm.get('IncomeSource').value
                "
              >
                {{ incomeSource.Description }}
              </option>
            </select>
            <div
              class="invalid-feedback d-block"
              *ngIf="
                ((additionalInfoForm.get('IncomeSource').touched ||
                  additionalInfoForm.get('IncomeSource').dirty) &&
                  !additionalInfoForm.get('IncomeSource').valid) ||
                (!additionalInfoForm.get('IncomeSource').valid &&
                  formSubmitAttempt); else selectionSource
              "
            >
              <span class="form-validator_error">
                <ng-container
                  *ngIf="
                    !!additionalInfoForm.get('IncomeSource').errors?.required
                  "
                >
                  {{ additionalInfoConfigData?.IncomeSourceRequired }}
                </ng-container>
              </span>
            </div>
            <ng-template #selectionSource>
              <div class="invalid-feedback d-block"
                *ngIf="!additionalInfoForm.get('IncomeSource').value"
              >
                <span class="form-validator_error">
                    Please make a selection
                </span>
              </div>
            </ng-template>
          </div>
        </div>
      </div>
      <div class="col-12 pb-3 pl-0" *ngIf="type === 'buyer'">
        <div class="form-group">
          <label>{{ additionalInfoConfigData?.CoBuyerLabel }}</label>
          <div class="px-0">
            <div class="custom-radio">
              <input
                type="radio"
                value="Yes"
                id="CoBuyerYes"
                formControlName="CoBuyer"
                tabindex="-1"
              />
              <label class="ml-lbl" id="lblCoBuyerYes" for="CoBuyerYes" tabindex="0" (keypress)="activateRadio($event)">
                {{ additionalInfoConfigData?.CoBuyerYes }}
              </label>
            </div>
            <div class="custom-radio ml-4">
              <input
                type="radio"
                value="No"
                id="CoBuyerNo"
                formControlName="CoBuyer"
                tabindex="-1"
              />
              <label class="ml-lbl" id="lblCoBuyerNo" for="CoBuyerNo" tabindex="0" (keypress)="activateRadio($event)">
                {{ additionalInfoConfigData?.CoBuyerNo }}
              </label>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
</div>

<div class="credit-app-cta-section">
  <div class="row m-0 w-100 cta-section">
    <div class="col-12 p-0 d-flex cta-col cta-alignment m-0">
      <button type="button" id="back_cta" class="secondary-cta mr-auto" [disabled]="isSaving" (click)="goBack()">
        {{ additionalInfoConfigData?.BackCta }}
      </button>
      <button id="next_cta" class="primary-cta ml-auto" [disabled]="!additionalInfoForm.valid || isSaving" (click)="goNext()">
        {{ additionalInfoConfigData?.NextCta }}
      </button>
    </div>
  </div>
</div>
